import React from 'react';
import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import GridSampleView from '../views/GridSampleView/GridSampleView';
import CardSampleView from '../views/CardSampleView/CardSampleView';
import ButtonSampleView from '../views/ButtonSampleView/ButtonSampleView';
import IconSampleView from '../views/IconSampleView/IconSampleView';
import LoaderSampleView from '../views/LoaderSampleView/LoaderSampleView';
import InputSampleView from '../views/InputSampleView/InputSampleView';
import ModalSampleView from '../views/ModalSampleView/ModalSampleView';

import MainView from '../views/MainView/MainView';

export default function () {
  return (
    <MainView>
      <Outlet />
      <Routes>
        <Route index path="grid" element={<GridSampleView />} />
        <Route index path="card" element={<CardSampleView />} />
        <Route index path="icon" element={<IconSampleView />} />
        <Route index path="button" element={<ButtonSampleView />} />
        <Route index path="input" element={<InputSampleView />} />
        <Route index path="loader" element={<LoaderSampleView />} />
        <Route index path="modal" element={<ModalSampleView />} />
        <Route path="*" element={<Navigate to="grid" replace />} />
      </Routes>
    </MainView>
  );
}
